import * as React from 'react';

function SvgProgressBookingConfirmed(props) {
  return (
    <svg width={18} height={18} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#progress-booking-confirmed_svg__clip0_227_7213)">
        <path d="M17.357 3.21h-3.214V2.087a.161.161 0 00-.16-.161h-1.126a.161.161 0 00-.16.16v1.126H9.722V2.086a.161.161 0 00-.16-.161H8.437a.161.161 0 00-.16.16v1.126H5.304V2.086a.161.161 0 00-.161-.161H4.018a.161.161 0 00-.16.16v1.126H.642A.642.642 0 000 3.854v11.57c0 .357.287.644.643.644h16.714a.642.642 0 00.643-.643V3.853a.642.642 0 00-.643-.642zm-.803 11.411H1.446V4.657h2.411v1.125c0 .088.072.16.16.16h1.126c.088 0 .16-.072.16-.16V4.657h2.974v1.125c0 .088.072.16.16.16h1.126c.088 0 .16-.072.16-.16V4.657h2.973v1.125c0 .088.073.16.161.16h1.125c.088 0 .16-.072.16-.16V4.657h2.412v9.964zM7.07 8.675H3.375a.161.161 0 00-.16.16V9.8c0 .088.072.16.16.16h3.696c.089 0 .161-.072.161-.16v-.964a.161.161 0 00-.16-.161zm0 2.732H3.375a.161.161 0 00-.16.16v.965c0 .088.072.16.16.16h3.696c.089 0 .161-.072.161-.16v-.964a.161.161 0 00-.16-.16zm6.192-3.564l-2.081 2.887-1.061-1.468a.317.317 0 00-.26-.133H8.76a.161.161 0 00-.13.255l2.292 3.178a.32.32 0 00.518 0l3.315-4.594a.161.161 0 00-.131-.255H13.52a.314.314 0 00-.257.13z" />
      </g>
      <defs>
        <clipPath id="progress-booking-confirmed_svg__clip0_227_7213">
          <path d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgProgressBookingConfirmed;
